<template>
  <div id="search"
       class="z4 border-left col col-12 md-col-6 lg-col-6">
    <div class="z4 sticky bg-fill">
      <form @submit.prevent="search" class="border-bottom sans">
        <input type="text" class="sans col-12" autocomplete="off" v-model="searchQuery" name="search" placeholder="Search" ref="searchInput" />
        <span v-if="searchInProgress" id="searching" class="red absolute blink">Searching...</span>
        <img id="search-close" class="absolute pointer" src="@/assets/icon-close.svg" alt="" @click="UPDATE_SHOW_SEARCH()">
      </form>
      <div id="search-filter" class="flex caps border-bottom fs-s reset-line-height">
        <div @click="showContentTypes = !showContentTypes" class="pointer flex-auto center relative col-6">
          <span class="noselect pointer block hover-red py1">{{ filteredByTitle }}</span>
          <ul v-if="showContentTypes" class="content-types list-reset absolute col-12 bg-light border-right border-bottom py1 m0">
            <li class="py1 pointer hover-red noselect" :class="{ active: filterByType === false }" @click="filterSearchResults(false)">All</li>
            <li class="py1 pointer hover-red noselect" :class="{ active: filterByType === 'investigation', disabled: !hasType('investigation') }" @click="filterSearchResults('investigation')">Investigations</li>
            <li class="py1 pointer hover-red noselect" :class="{ active: filterByType === 'study', disabled: !hasType('study') }" @click="filterSearchResults('study')">Studies</li>
            <li class="py1 pointer hover-red noselect" :class="{ active: filterByType === 'exhibition', disabled: !hasType('exhibition') }" @click="filterSearchResults('exhibition')">Exhibitions</li>
            <li class="py1 pointer hover-red noselect" :class="{ active: filterByType === 'event', disabled: !hasType('event') }" @click="filterSearchResults('event')">Events</li>
            <li class="py1 pointer hover-red noselect" :class="{ active: filterByType === 'news', disabled: !hasType('news') }" @click="filterSearchResults('news')">News</li>
            <li class="py1 pointer hover-red noselect" :class="{ active: filterByType === 'publication', disabled: !hasType('publication') }" @click="filterSearchResults('publication')">Publications</li>
            <li class="py1 pointer hover-red noselect" :class="{ active: filterByType === 'press', disabled: !hasType('press') }" @click="filterSearchResults('press')">Press</li>
            <li class="py1 pointer hover-red noselect" :class="{ active: filterByType === 'page', disabled: !hasType('page') }" @click="filterSearchResults('page')">Pages</li>
            <li class="py1 pointer hover-red noselect" :class="{ active: filterByType === 'people-orgs', disabled: !hasType('people-orgs') }" @click="filterSearchResults('people-orgs')">People</li>
          </ul>
        </div>
        <div @click="showSort = !showSort" class="pointer flex-auto center border-left relative col-6">
          <span class="noselect block hover-red py1">{{ sortedByTitle }}</span>
          <ul v-show="showSort" class="sort-types list-reset absolute col-12 bg-light border-left border-bottom py1 m0">
            <li class="py1 pointer hover-red noselect" :class="{ active: sortBy === false }" @click="sortSearchResults(false)">Relevance</li>
            <li class="py1 pointer hover-red noselect" :class="{ active: sortBy === 'title' }" @click="sortSearchResults('title')">Title</li>
            <li class="py1 pointer hover-red noselect" :class="{ active: sortBy === 'date' }" @click="sortSearchResults('date')">Date</li>
          </ul>
        </div>
      </div>
    </div>

    <ul id="search-results" v-if="searchResults" class="p0 m0 list-reset">
      <search-result v-for="(item, index) in searchResultsProcessed" :key="`result-${index}`" :item="item"></search-result>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import CardBlock from '@/components/CardBlock'
import SearchResult from '@/components/SearchResult'
import { debounce } from 'underscore'
import { isStudy } from '@/utils'

export default {

  name: 'Search',

  data () {
    return {
      item: null,
      // keywords: null,
      query: null,
      showContentTypes: false,
      showSort: false,
      filterByType: false,
      sortBy: false
    }
  },

  props: ['showSearch'],

  components: {
    CardBlock,
    SearchResult
  },

  computed: {
    ...mapState([
      'searchInProgress',
      'searchResults',
      'subdomains'
    ]),
    currentSubdomain () {
      if (!this.subdomains) return null;
      const domain = this.subdomains.filter(x => {
        return x.slug === this.$route.params.subdomain
      })
      if (domain.length == 1) {
        return domain[0]
      } else {
        return null
      }
    },
    filteredByTitle () {
      if (this.filterByType) {
        if (this.filterByType == 'investigation') {
          return 'Filter: Investigations'
        } else if (this.filterByType == 'study') {
          return 'Filter: Studies'
        } else if (this.filterByType == 'exhibition') {
          return 'Filter: Exhibitions'
        } else if (this.filterByType == 'event') {
          return 'Filter: Events'
        } else if (this.filterByType == 'publication') {
          return 'Filter: Publications'
        } else if (this.filterByType == 'news') {
          return 'Filter: News'
        } else if (this.filterByType == 'press') {
          return 'Filter: Press'
        } else if (this.filterByType == 'page') {
          return 'Filter: Pages'
        } else if (this.filterByType == 'people-orgs') {
          return 'Filter: People'
        }
      } else {
        return 'Filter by Type'
      }
    },
    sortedByTitle () {
      if (this.sortBy) {
        if (this.sortBy == 'title') {
          return 'Sorted by Title'
        } else if (this.sortBy == 'date') {
          return 'Sorted by Date'
        }
      } else {
        return 'Sorted by Relevance'
      }
    },
    searchQuery: {
      get () {
        return this.$store.state.searchQuery
      },
      set (value) {
        this.$store.commit('UPDATE_SEARCH_QUERY', value)
      }
    },
    searchResultsProcessed () {
      let results = this.searchResults

      if (this.filterByType) {
        if (this.filterByType === 'people-orgs') {
          results = this.searchResults.filter(x => {
            return x.post_type === 'person'
          })
        } else if (this.filterByType === 'study') {
          results = results.filter(isStudy)
        } else if (this.filterByType === 'investigation') {
          results = results.filter(x => x.post_type === this.filterByType).filter(x => !isStudy(x))
        } else {
          results = this.searchResults.filter(x => x.post_type === this.filterByType)
        }
      } else {
        results = this.searchResults
      }

      if (this.sortBy) {
        if (this.sortBy == 'title') {
          results.sort(function (a, b) {
            if(a.post_name < b.post_name) {
              return -1
            } else {
              return 1
            }
          })
        } else if (this.sortBy == 'date') {
          results.sort(function (a, b) {
            if(a.post_date < b.post_date) {
              return -1
            } else {
              return 1
            }
          })
        }
      } else {
        results.sort(function (a, b) {
          if (a.relevance_score > b.relevance_score) {
            return -1
          } else {
            return 1
          }
        })
      }

      return results
    }
  },

  methods: {
    ...mapActions([
      'search'
    ]),
    ...mapMutations([
      'UPDATE_SHOW_SEARCH'
    ]),
    debounce,
    filterSearchResults (type) {
      this.filterByType = type
    },
    hasType (type) {
      let results = this.searchResults
      if (type === 'people-orgs') {
        results = results.filter(x => {
          return (x.post_type === 'person' || x.post_type === 'organization')
        })
      } else if (type === 'study') {
        results = results.filter(isStudy)
      } else if (type === 'investigation') {
        results = results.filter(x => !isStudy(x))
      } else {
        results = results.filter(x => x.post_type === type)
      }
      return results.length
    },
    sortSearchResults (type) {
      this.sortBy = type
    }
  },

  watch: {
    searchQuery: debounce(function () {
      this.filterByType = false
      this.sortBy = false
      this.search()
    }, 500),
    showSearch: function () {
      if (this.showSearch) {
        this.$refs.searchInput.focus()
      }
    }
  }
}
</script>

<style lang="css">
  #search {
    background: var(--col-light);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    overflow-y: scroll;
    overflow-x: hidden;
    z-index: 9999;

    &::-webkit-scrollbar {
      width: 0px;  /* remove scrollbar space */
      background: transparent;  /* optional: just make scrollbar invisible */
    }
    /* optional: show position indicator in red */
    &::-webkit-scrollbar-thumb {
      background: #FF0000;
    }
    /* width */
    &::-webkit-scrollbar {
      width: 2px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: rgb(255,230,230);
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: var(--red);
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: var(--red);
    }

    #searching {
      top: 0.76em;
      right: 3.5em;
    }

    #search-close {
      height: 18px;
      top: 0;
      right: 0.5em;
      padding: 0.8em;
    }

    form {
      padding: 0.81em;
      position: sticky;
      top: 0;
      background: var(--col-light);

      input[type="submit"] {
        right: 0;
      }
    }

    input[type="text"] {
      outline: none;
      background: none;
      border: none;
      font-size: 16px;
      width: 100%;
    }

    #search-results {
      a:hover {
        color: var(--red);
      }

      .router-link-exact-active {
        display: block;
        opacity: 0.2;

        &:hover {
          opacity: 1;
        }
      }
    }

    .content-types, .sort-types {
      li.active {
        color: red;
      }
      li.disabled {
        opacity: 0.2;
        pointer-events: none;
      }
    }

    .sort-types {
      left: -1px;
    }
  }

  @-moz-document url-prefix() {
    #search form {
      padding: 0.73em;
    }
  }

  @media not all and (min-resolution:.001dpcm){ @supports (-webkit-appearance:none) {
    #search form {
      padding: 0.7em;
    }
  }}

</style>
